var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "780px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("edit")]),
              _vm._v(" Editar solicitud con cargo a vacación\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "pt-0" },
                [
                  _c(
                    "v-container",
                    { staticClass: "pt-0", attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c("p", [
                              _vm._v("\n                Tipo de permiso : "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.form.tipo_permiso))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("p", { staticClass: "titulo" }, [
                            _vm._v("Total dias de vacación :")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "texto" }, [
                            _vm._v(_vm._s(this.tiempo_vacaciones) + " dias")
                          ]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c("p", { staticClass: "titulo" }, [
                            _vm._v("Total dias solicitados :")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "texto" }, [
                            _vm._v(
                              _vm._s(this.total_dias_solicitadas) + " dias"
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                        _c("p", { staticClass: "titulo" }, [
                          _vm._v("Total dias no programados :")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "texto" }, [
                          _vm._v(
                            _vm._s(this.total_dias_no_programados) + " dias"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "date",
                                  label: "Fecha",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.calculaDiasSolicitados(false)
                                  },
                                  change: function($event) {
                                    return _vm.calculaDiasSolicitados(true)
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_desde,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_desde", $$v)
                                  },
                                  expression: "form.fecha_desde"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "date",
                                  label: "Fecha hasta",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.calculaDiasSolicitados(false)
                                  },
                                  change: function($event) {
                                    return _vm.calculaDiasSolicitados(true)
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_retorno,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_retorno", $$v)
                                  },
                                  expression: "form.fecha_retorno"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-radio-group",
                                {
                                  attrs: {
                                    row: "",
                                    rules: [
                                      function(v) {
                                        if (v == null) {
                                          return "El campo es obligatorio."
                                        }
                                        return true
                                      }
                                    ]
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.calculaDiasSolicitados(true)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.rango_horario,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "rango_horario", $$v)
                                    },
                                    expression: "form.rango_horario"
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs4: "" } },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: "Todo el día",
                                          value: 0
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs4: "" } },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: "Solo mañana",
                                          value: 1
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs4: "" } },
                                    [
                                      _c("v-radio", {
                                        attrs: { label: "Solo tarde", value: 2 }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "pr-4" },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("save")]),
                      _vm._v("\n          Guardar\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-101b543e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-101b543e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/dialogs/EditarPermisoCargoVacacion.vue
// module id = null
// module chunks = 